import { Selected } from '@optimus-web/core';

export const normalizeSelectedValueToArray = (value: Selected): string[] => {
    if (Array.isArray(value)) {
        return value as string[];
    }

    if (typeof value === 'string') {
        return [value];
    }

    return [];
};
